<template>
  <v-container fluid class="mb-10">
    <v-card elevation="0" color="transparent">
      <v-row justify="center" align="center">
        <v-col cols="12" sm="12">
          <v-row align="center" justify="center" class="mt-12 text-center">
            <v-col cols="12" sm="4">
              <v-hover>
                <template v-slot:default="{ hover }">
                  <v-card class="elevation-12" @click="similarity_catalog">
                    <v-toolbar dark color="primary">
                      <v-toolbar-title>{{
                        $t("similarity.catalog_similarity.name")
                      }}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>{{
                      $t("similarity.catalog_similarity.desc")
                    }}</v-card-text>
                    <v-fade-transition>
                      <v-overlay v-if="hover" absolute dark>
                        <v-btn icon>
                          <v-icon>mdi-image</v-icon>
                        </v-btn>
                      </v-overlay>
                    </v-fade-transition>
                  </v-card>
                </template>
              </v-hover>
            </v-col>
            <v-col cols="12" sm="4">
              <v-hover>
                <template v-slot:default="{ hover }">
                  <v-card class="elevation-12" @click="similarity_upload">
                    <v-toolbar dark color="primary">
                      <v-toolbar-title>{{
                        $t("similarity.upload_similarity.name")
                      }}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                      {{ $t("similarity.upload_similarity.desc") }}
                    </v-card-text>
                    <v-fade-transition>
                      <v-overlay v-if="hover" absolute dark>
                        <v-btn icon>
                          <v-icon>mdi-attachment</v-icon>
                        </v-btn>
                      </v-overlay>
                    </v-fade-transition>
                  </v-card>
                </template>
              </v-hover>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="$store.state.show.similariy_rest" cols="12" sm="11">
          <v-card outlined>
            <v-row
              justify="center"
              align="center"
              v-if="this.similarity && this.similarity[1]['Request Details']"
            >
              <v-col cols="4" md="2">
                <v-img
                  :src="this.similarity[1]['Request Details']['picture url']"
                  :lazy-src="
                    this.similarity[1]['Request Details']['picture url']
                  "
                  :aspect-ratio="1"
                ></v-img>
              </v-col>
              <v-col cols="12" sm="auto" class="text-center">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title
                      >Selected product infos.</v-list-item-title
                    >
                    <v-list-item-subtitle
                      >Most precise category :
                      <span class="primary--text">
                        {{
                          this.similarity[0]["Request"]["Most precise category"]
                        }}
                      </span></v-list-item-subtitle
                    >
                    <v-list-item-subtitle>
                      product id :
                      <span class="primary--text">
                        {{ this.similarity[0]["Request"]["Product id"] }}
                      </span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="ma-0 pa-0">
                  <v-list-item-content>
                    <v-list-item-title
                      >Similarity Request details</v-list-item-title
                    >
                    <v-list-item-subtitle>
                      maximum similarity required :
                      <span class="primary--text">
                        {{
                          this.similarity[1]["Request Details"][
                            "maximum similarity required"
                          ]
                        }}
                      </span>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      minimum similarity required :
                      <span class="primary--text">
                        {{
                          this.similarity[1]["Request Details"][
                            "minimum similarity required"
                          ]
                        }}
                      </span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-card>
          <v-card outlined flat tile class="d-flex" elevation="1">
            <v-tabs
              v-model="tabs"
              background-color="#fafafa"
              color="rgb(17, 65, 206)"
              fixed-tabs
            >
              <v-tab>
                <strong>Similarity</strong>
                <v-badge
                  color="green"
                  v-if="
                    this.similarity &&
                    this.similarity[3] &&
                    this.similarity[3]['number of results']
                  "
                  :content="this.similarity[3]['number of results']"
                >
                </v-badge>
              </v-tab>
              <v-tab disabled>
                <strong>Labelisation</strong>
              </v-tab>
              <v-tab-item>
                <ProductMuch :similarity="similarity" />
              </v-tab-item>
              <v-tab-item disabled>
                <!-- <ProductDetails :similarity="similarity" /> -->
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import ProductMuch from "@/components/similarity/Products_match";
import ProductDetails from "@/components/similarity/Product_details";

export default {
  name: "Similarity",
  components: {
    ProductMuch,
    ProductDetails,
  },
  data: () => ({
    tabs: null,
    similarity: null,
  }),
  computed: {},
  mounted() {
    this.$store.state.show.similariy_rest = false;
  },
  destroyed() {
    this.$store.dispatch("selector/select", {
      active: false,
    });
  },
  methods: {
    similarity_upload() {
      this.$store.dispatch("setSnackbar", {
        text: "avilable soon",
        color: "info",
      });
    },
    similarity_catalog() {
      this.$store.state.show.similariy_rest = false;
      this.$store
        .dispatch("selector/select", {
          active: true,
          multiple: false,
        })
        .then((p) => {
          this.$store.dispatch("setLoader", {
            showing: true,
            text: "Runnig similarity please wait ...",
          });
          this.$store
            .dispatch("SIMILARITY_UPLOAD", p)
            .then((r) => {
              this.$store.dispatch("setLoader", {
                showing: false,
              });
              this.similarity = r;
              if (this.similarity.length) {
                this.$store.state.show.similariy_rest = true;
              }
            })
            .catch((err) => {
              this.$store.dispatch("setLoader", {
                showing: false,
              });
              this.$store.dispatch("setSnackbar", {
                text: err,
                color: "error",
              });
            });
        });
    },
  },
};
</script>

<style>
.scroll {
  overflow: hidden scroll !important;
  scroll-behavior: smooth;
  max-height: 650px !important;
}
.scroll::-webkit-scrollbar {
  width: 7px;
  height: 15%; /* width of the entire scrollbar */
}
.scroll::-webkit-scrollbar-track {
  background: #80808038;
  border-radius: 20px; /* color of the tracking area */
}
.scroll::-webkit-scrollbar-thumb {
  background-color: #1a4dcd; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 1px solid grey; /* creates padding around scroll thumb */
}
.input-btn {
  font-weight: 600;
}
.preview-container .picture-preview {
  z-index: auto !important;
}
.colors-btn {
  position: absolute;
  right: 2px;
  top: 2px;
  width: 24px !important;
  height: 23px !important;
}
.match_btn {
  position: absolute;
  top: 0px;
  left: -7px;
  margin: -4px;
}
</style>
